export default "__VITE_PUBLIC_ASSET__a7a5ed36__"